import React from 'react';

import { iconComponents } from './IconImports';

interface IconProps {
  name: keyof typeof iconComponents;
  className?: string;
  style?: React.CSSProperties;
}

export const Icon: React.FC<IconProps> = ({ name, className, style }) => {
  // Select the icon component based on the name prop
  const SelectedIcon = iconComponents[name] as unknown as React.ComponentType<
    React.HTMLAttributes<HTMLElement>
  >;

  if (!SelectedIcon) {
    console.warn(
      `Icon with name "${name}" does not exist. Please check the name.`
    );

    return 'N/D';
  }

  return <SelectedIcon aria-label={name} className={className} style={style} />;
};
